module.exports = __webpack_public_path__ + "static/media/pexels-brett-sayles-1340502.d60a1f7b.jpg";